import { Emitter } from 'nanoevents';
import { IDocInfo } from '@src/slide/domain/slide-app/core/interfaces/doc-info.interface';
import { ISlideLock } from '../../scenes/online/core/interfaces/cooperation-lock-manager.interface';
import { ILoadLog } from '../../scenes/online/core/interfaces/online-edit-service.interface';
import { IAppServices } from './app-service.interface';
import { IClientVars } from './client-vars.interface';

export const enum EditEvents {
    /** 分片导入成功 */
    LoadDocumentAllChunksSuccess = 'load-document-all-chunks-success',

    /** 文档打开失败 */
    LoadDocumentError = 'load-document-error',

    /** 文档信息准备完成 */
    DocInfoReady = 'doc-info-ready',

    /** 获取文档信息失败 */
    LoadDocInfoError = 'load-doc-info-error',

    /** 房间锁相关事件 */
    Lock = 'lock',
    Unlock = 'unlock',
    LockInfoUpdate = 'lock-info-update',

    /** 光标相关事件 */
    CursorInfoUpdate = 'cursor-info-update',

    /** 文档权限相关事件 */
    SetVisibleFailed = 'setVisibleFailed',
    SetDocCopyable = 'setDocCopyable',
    SetDocEditable = 'setDocEditable',

    // 展示恢复窗口
    ShowSnapShotModal = 'show-snap-shot-modal',
    // appService 加载完成
    AppServiceProviderLoaded = 'app-service-provider-loaded',
    // 移动App和桌面App中会加载 offlineDBService
    OfflineDBServiceReady = 'offline-db-service-ready',
    // 移动App和桌面App准备好恢复离线数据
    UseOfflineData = 'use-offline-data',
    // 首屏加载完成
    FirstPageDisplay = 'first-page-display',

    // 控制角标的显示与隐藏
    CornerMarkVisible = 'unHiddon',

    ClientVarChanged = 'client-var-changed',

    // 同步盘线程连接成功
    SyncWorkerConnected = 'sync-worker-connected',
}

/**
 * 在线编辑事件
 */
export interface IEditEventMap {
    [EditEvents.LoadDocumentAllChunksSuccess]: (loadLog: ILoadLog) => void;
    [EditEvents.DocInfoReady]: (docInfo: IDocInfo) => void;
    [EditEvents.LoadDocInfoError]: (err: string) => void;
    [EditEvents.Lock]: (lockInfo: ISlideLock[]) => void;
    [EditEvents.Unlock]: (lockInfo: ISlideLock[]) => void;
    [EditEvents.LockInfoUpdate]: (lockInfo: ISlideLock[]) => void;
    [EditEvents.CursorInfoUpdate]: (cursorInfo: { isNew: boolean }) => void;
    [EditEvents.SetVisibleFailed]: () => void;
    [EditEvents.SetDocCopyable]: () => void;
    [EditEvents.SetDocEditable]: () => void;
    [EditEvents.LoadDocumentError]: (e?: any) => void;
    [EditEvents.ShowSnapShotModal]: () => void;
    [EditEvents.AppServiceProviderLoaded]: (appService: IAppServices, noEditServices?: IAppServices) => void;
    [EditEvents.OfflineDBServiceReady]: () => void;
    [EditEvents.UseOfflineData]: () => void;
    [EditEvents.ClientVarChanged]: (clientVar: IClientVars) => void;
    [EditEvents.SyncWorkerConnected]: () => void;
}

export type IEditEvents = Emitter<IEditEventMap>;
